const IconInstagramGradient = (): JSX.Element => {
  return (
    <>
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="-703.51"
          y1="696.79"
          x2="-697.84"
          y2="691.13"
          gradientTransform="translate(2704.51 -2654.73) scale(3.84)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffd521" />
          <stop offset=".05" stopColor="#ffd521" />
          <stop offset=".5" stopColor="#f50000" />
          <stop offset=".95" stopColor="#b900b4" />
          <stop offset=".95" stopColor="#b900b4" />
          <stop offset="1" stopColor="#b900b4" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="-913.52"
          y1="573.09"
          x2="-912.84"
          y2="572.41"
          gradientTransform="translate(29232.06 -18315) scale(32)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffd521" />
          <stop offset=".05" stopColor="#ffd521" />
          <stop offset=".5" stopColor="#f50000" />
          <stop offset=".95" stopColor="#b900b4" />
          <stop offset=".95" stopColor="#b900b4" />
          <stop offset="1" stopColor="#b900b4" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="-886.06"
          y1="588.8"
          x2="-884.74"
          y2="587.47"
          gradientTransform="translate(14558.28 -9652.52) scale(16.43)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffd521" />
          <stop offset=".05" stopColor="#ffd521" />
          <stop offset=".5" stopColor="#f50000" />
          <stop offset=".95" stopColor="#b900b4" />
          <stop offset=".95" stopColor="#b900b4" />
          <stop offset="1" stopColor="#b900b4" />
        </linearGradient>
      </defs>
      <path
        d="M19.85,5.6c0-.8-.64-1.44-1.44-1.44-.8,0-1.44.64-1.44,1.44h0c0,.8.65,1.44,1.44,1.44.8,0,1.44-.65,1.44-1.44"
        fill="url(#linear-gradient)"
      />
      <path
        d="M21.77,16.85c-.05,1.17-.25,1.81-.41,2.23-.19.52-.5.99-.9,1.38-.39.4-.86.71-1.38.9-.42.17-1.06.36-2.23.42-1.26.06-1.64.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.06-1.81-.25-2.23-.42-.56-.22-.96-.48-1.38-.9-.4-.39-.71-.86-.9-1.38-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.59.07-4.85c.05-1.17.25-1.81.41-2.23.19-.52.5-.99.9-1.38.39-.4.86-.71,1.38-.9.42-.16,1.06-.36,2.23-.41,1.26-.06,1.64-.07,4.85-.07s3.58.01,4.85.07c1.17.06,1.81.25,2.23.41.52.19.99.5,1.38.9.42.42.68.82.9,1.38.16.43.36,1.06.41,2.23.06,1.26.07,1.64.07,4.85s-.01,3.58-.07,4.85ZM23.93,7.05c-.06-1.28-.26-2.15-.56-2.91-.3-.8-.77-1.53-1.38-2.13-.6-.61-1.32-1.08-2.12-1.38-.76-.3-1.64-.5-2.91-.56-1.28-.06-1.69-.07-4.95-.07s-3.67.01-4.95.07c-1.28.06-2.15.26-2.91.56-.8.3-1.52.77-2.12,1.38-.61.6-1.08,1.33-1.39,2.13-.3.76-.5,1.64-.56,2.91-.05,1.28-.07,1.69-.07,4.95s.01,3.67.07,4.95c.06,1.28.26,2.15.56,2.91.3.8.77,1.53,1.39,2.12.6.61,1.32,1.08,2.12,1.39.77.3,1.64.5,2.91.56,1.28.06,1.69.07,4.95.07s3.67-.01,4.95-.07c1.28-.06,2.15-.26,2.91-.56.8-.3,1.52-.77,2.12-1.39.61-.6,1.08-1.32,1.38-2.12.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95Z"
        fill="url(#linear-gradient-2)"
      />
      <path
        d="M12,16c-2.21,0-4-1.79-4-4h0c0-2.21,1.79-4,4-4,2.21,0,4,1.79,4,4h0c0,2.21-1.79,4-4,4ZM12,5.84c-3.4,0-6.16,2.76-6.16,6.17,0,3.4,2.76,6.16,6.16,6.16h0c3.4,0,6.16-2.76,6.16-6.16s-2.76-6.17-6.16-6.17Z"
        fill="url(#linear-gradient-3)"
      />
    </>
  );
};

export default IconInstagramGradient;
